import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ChevronLeft, ChevronRight, Pencil, Trash } from "lucide-react";
import { useState } from "react";
import DeleteBlueprint from "./DeleteBlueprint";
import BlueprintDetailsDialog from "./BlueprintDetailsDialog";
type Blueprint = {
  id: string;
  name: string;
  description: string;
  createdAt: string;
  creatorName: string;
  defaultMode: string;
};

export const blueprints: Blueprint[] = [
  {
    id: "1",
    name: "Customer Support Assistant",
    description: "Handles customer inquiries and provides helpful responses.",
    createdAt: "2026-09-01T10:30:00Z",
    creatorName: "Ahmed Hassan",
    defaultMode: "agentic",
  },
  {
    id: "2",
    name: "Data Analysis Blueprint",
    description: "Analyzes datasets and generates insights and summaries.",
    createdAt: "2026-08-28T14:15:00Z",
    creatorName: "Sara Mohamed",
    defaultMode: "auto",
  },
  {
    id: "3",
    name: "Content Generator",
    description: "Creates and formats content based on user requirements.",
    createdAt: "2026-08-25T09:45:00Z",
    creatorName: "Omar Ali",
    defaultMode: "agentic",
  },
  {
    id: "4",
    name: "Research Assistant",
    description: "Researches topics and summarizes relevant information.",
    createdAt: "2026-08-20T16:20:00Z",
    creatorName: "Mariam Khaled",
    defaultMode: "auto",
  },
  {
    id: "5",
    name: "Email Assistant",
    description: "Drafts professional emails and manages email-related tasks.",
    createdAt: "2026-08-18T11:10:00Z",
    creatorName: "Youssef Ahmed",
    defaultMode: "auto",
  },
  {
    id: "6",
    name: "Code Review Assistant",
    description: "Reviews code and provides suggestions for improvements.",
    createdAt: "2026-08-15T13:40:00Z",
    creatorName: "Nour Adel",
    defaultMode: "agentic",
  },
  {
    id: "7",
    name: "Sales Assistant",
    description: "Assists sales teams with leads, prospects, and follow-ups.",
    createdAt: "2026-08-12T10:20:00Z",
    creatorName: "Hana Mahmoud",
    defaultMode: "agentic",
  },
  {
    id: "8",
    name: "Marketing Planner",
    description: "Creates marketing strategies, campaigns, and content plans.",
    createdAt: "2026-08-10T12:30:00Z",
    creatorName: "Karim Mostafa",
    defaultMode: "auto",
  },
  {
    id: "9",
    name: "Meeting Summarizer",
    description: "Summarizes meetings and extracts key decisions and actions.",
    createdAt: "2026-08-08T09:15:00Z",
    creatorName: "Laila Ahmed",
    defaultMode: "auto",
  },
  {
    id: "10",
    name: "HR Assistant",
    description: "Helps employees with HR questions and internal policies.",
    createdAt: "2026-08-06T15:40:00Z",
    creatorName: "Mostafa Samir",
    defaultMode: "agentic",
  },
  {
    id: "11",
    name: "Document Analyzer",
    description: "Extracts and analyzes important information from documents.",
    createdAt: "2026-08-04T11:25:00Z",
    creatorName: "Dina Adel",
    defaultMode: "auto",
  },
  {
    id: "12",
    name: "Financial Assistant",
    description: "Analyzes financial data and generates useful reports.",
    createdAt: "2026-08-02T14:10:00Z",
    creatorName: "Amr Hassan",
    defaultMode: "agentic",
  },
  {
    id: "13",
    name: "Invoice Processor",
    description:
      "Processes invoices and extracts relevant billing information.",
    createdAt: "2026-07-30T10:45:00Z",
    creatorName: "Nourhan Ali",
    defaultMode: "auto",
  },
  {
    id: "14",
    name: "Product Recommendation Assistant",
    description: "Recommends products based on customer preferences.",
    createdAt: "2026-07-28T13:20:00Z",
    creatorName: "Ahmed Samy",
    defaultMode: "agentic",
  },
  {
    id: "15",
    name: "Knowledge Base Assistant",
    description:
      "Finds and summarizes information from internal knowledge bases.",
    createdAt: "2026-07-25T16:30:00Z",
    creatorName: "Salma Youssef",
    defaultMode: "auto",
  },
  {
    id: "16",
    name: "Project Manager",
    description: "Tracks project progress, tasks, deadlines, and milestones.",
    createdAt: "2026-07-23T09:50:00Z",
    creatorName: "Mahmoud Tarek",
    defaultMode: "agentic",
  },
  {
    id: "17",
    name: "Task Planner",
    description: "Organizes tasks and creates structured action plans.",
    createdAt: "2026-07-20T12:15:00Z",
    creatorName: "Aya Khaled",
    defaultMode: "auto",
  },
  {
    id: "18",
    name: "SEO Assistant",
    description: "Analyzes content and provides SEO optimization suggestions.",
    createdAt: "2026-07-18T14:35:00Z",
    creatorName: "Omar Hassan",
    defaultMode: "agentic",
  },
  {
    id: "19",
    name: "Social Media Assistant",
    description: "Creates social media posts and engagement strategies.",
    createdAt: "2026-07-16T11:40:00Z",
    creatorName: "Farah Mohamed",
    defaultMode: "auto",
  },
  {
    id: "20",
    name: "Translation Assistant",
    description: "Translates and adapts content across multiple languages.",
    createdAt: "2026-07-14T10:05:00Z",
    creatorName: "Yassin Adel",
    defaultMode: "auto",
  },
  {
    id: "21",
    name: "Legal Document Assistant",
    description: "Reviews legal documents and highlights important sections.",
    createdAt: "2026-07-12T15:25:00Z",
    creatorName: "Mariam Ahmed",
    defaultMode: "agentic",
  },
  {
    id: "22",
    name: "Contract Analyzer",
    description: "Analyzes contracts and identifies key terms and clauses.",
    createdAt: "2026-07-10T13:10:00Z",
    creatorName: "Khaled Mostafa",
    defaultMode: "auto",
  },
  {
    id: "23",
    name: "Operations Assistant",
    description: "Helps teams manage daily operational workflows.",
    createdAt: "2026-07-08T09:30:00Z",
    creatorName: "Nada Ibrahim",
    defaultMode: "agentic",
  },
  {
    id: "24",
    name: "Quality Assurance Assistant",
    description: "Reviews processes and identifies potential quality issues.",
    createdAt: "2026-07-06T16:15:00Z",
    creatorName: "Tamer Ali",
    defaultMode: "auto",
  },
  {
    id: "25",
    name: "Customer Feedback Analyzer",
    description: "Analyzes customer feedback and identifies common trends.",
    createdAt: "2026-07-04T11:50:00Z",
    creatorName: "Heba Samir",
    defaultMode: "agentic",
  },
  {
    id: "26",
    name: "Business Intelligence Assistant",
    description: "Turns business data into actionable insights and summaries.",
    createdAt: "2026-07-02T14:45:00Z",
    creatorName: "Sherif Ahmed",
    defaultMode: "auto",
  },
  {
    id: "27",
    name: "Recruitment Assistant",
    description:
      "Helps recruiters organize candidates and recruitment workflows.",
    createdAt: "2026-06-30T10:30:00Z",
    creatorName: "Rana Mahmoud",
    defaultMode: "agentic",
  },
  {
    id: "28",
    name: "Resume Analyzer",
    description:
      "Analyzes resumes and extracts relevant candidate information.",
    createdAt: "2026-06-28T12:40:00Z",
    creatorName: "Youssef Khaled",
    defaultMode: "auto",
  },
  {
    id: "29",
    name: "Interview Assistant",
    description:
      "Generates interview questions and evaluates candidate responses.",
    createdAt: "2026-06-26T15:20:00Z",
    creatorName: "Mai Hassan",
    defaultMode: "agentic",
  },
  {
    id: "30",
    name: "Training Assistant",
    description: "Creates training materials and learning resources.",
    createdAt: "2026-06-24T09:45:00Z",
    creatorName: "Mohamed Adel",
    defaultMode: "auto",
  },
  {
    id: "31",
    name: "Compliance Assistant",
    description: "Helps teams understand and follow compliance requirements.",
    createdAt: "2026-06-22T13:35:00Z",
    creatorName: "Reem Ahmed",
    defaultMode: "agentic",
  },
  {
    id: "32",
    name: "Report Generator",
    description: "Generates structured reports from provided business data.",
    createdAt: "2026-06-20T11:15:00Z",
    creatorName: "Adham Mostafa",
    defaultMode: "auto",
  },
  {
    id: "33",
    name: "Presentation Assistant",
    description: "Creates presentation outlines and organizes slide content.",
    createdAt: "2026-06-18T14:25:00Z",
    creatorName: "Hana Ali",
    defaultMode: "agentic",
  },
  {
    id: "34",
    name: "Research Analyst",
    description:
      "Collects information and produces structured research summaries.",
    createdAt: "2026-06-16T10:50:00Z",
    creatorName: "Seif Hassan",
    defaultMode: "auto",
  },
  {
    id: "35",
    name: "Competitor Analysis Assistant",
    description: "Analyzes competitors and compares products and services.",
    createdAt: "2026-06-14T12:05:00Z",
    creatorName: "Nada Mohamed",
    defaultMode: "agentic",
  },
  {
    id: "36",
    name: "Product Manager Assistant",
    description:
      "Helps product teams manage requirements and product roadmaps.",
    createdAt: "2026-06-12T15:45:00Z",
    creatorName: "Karim Ahmed",
    defaultMode: "auto",
  },
  {
    id: "37",
    name: "Requirements Analyzer",
    description:
      "Analyzes product requirements and identifies missing details.",
    createdAt: "2026-06-10T09:20:00Z",
    creatorName: "Salma Hassan",
    defaultMode: "agentic",
  },
  {
    id: "38",
    name: "Bug Report Assistant",
    description: "Creates clear and structured software bug reports.",
    createdAt: "2026-06-08T11:35:00Z",
    creatorName: "Ali Mahmoud",
    defaultMode: "auto",
  },
  {
    id: "39",
    name: "Documentation Assistant",
    description: "Creates and maintains technical and product documentation.",
    createdAt: "2026-06-06T14:15:00Z",
    creatorName: "Mona Adel",
    defaultMode: "agentic",
  },
  {
    id: "40",
    name: "Code Documentation Generator",
    description: "Generates documentation and explanations for source code.",
    createdAt: "2026-06-04T10:40:00Z",
    creatorName: "Hossam Ali",
    defaultMode: "auto",
  },
  {
    id: "41",
    name: "API Assistant",
    description: "Helps developers understand and work with APIs.",
    createdAt: "2026-06-02T13:25:00Z",
    creatorName: "Mariam Hassan",
    defaultMode: "agentic",
  },
  {
    id: "42",
    name: "Database Assistant",
    description: "Helps analyze database structures and write queries.",
    createdAt: "2026-05-30T16:10:00Z",
    creatorName: "Ahmed Nabil",
    defaultMode: "auto",
  },
  {
    id: "43",
    name: "SQL Query Generator",
    description:
      "Generates SQL queries based on natural language requirements.",
    createdAt: "2026-05-28T09:55:00Z",
    creatorName: "Sara Adel",
    defaultMode: "agentic",
  },
  {
    id: "44",
    name: "DevOps Assistant",
    description:
      "Assists with deployment, infrastructure, and DevOps workflows.",
    createdAt: "2026-05-26T12:20:00Z",
    creatorName: "Khaled Ahmed",
    defaultMode: "auto",
  },
  {
    id: "45",
    name: "Security Assistant",
    description:
      "Reviews systems and provides security-related recommendations.",
    createdAt: "2026-05-24T15:35:00Z",
    creatorName: "Nour Mohamed",
    defaultMode: "agentic",
  },
  {
    id: "46",
    name: "Workflow Automation Assistant",
    description: "Identifies opportunities to automate repetitive workflows.",
    createdAt: "2026-05-22T11:05:00Z",
    creatorName: "Mostafa Hassan",
    defaultMode: "auto",
  },
  {
    id: "47",
    name: "Data Cleaning Assistant",
    description:
      "Cleans datasets and identifies missing or inconsistent values.",
    createdAt: "2026-05-20T13:50:00Z",
    creatorName: "Lamia Ahmed",
    defaultMode: "agentic",
  },
  {
    id: "48",
    name: "Survey Analyzer",
    description: "Analyzes survey responses and summarizes key findings.",
    createdAt: "2026-05-18T10:15:00Z",
    creatorName: "Tarek Mohamed",
    defaultMode: "auto",
  },
  {
    id: "49",
    name: "Customer Insights Assistant",
    description: "Identifies customer behavior patterns and business insights.",
    createdAt: "2026-05-16T14:30:00Z",
    creatorName: "Aya Hassan",
    defaultMode: "agentic",
  },
  {
    id: "50",
    name: "Product Description Generator",
    description:
      "Creates engaging product descriptions from basic information.",
    createdAt: "2026-05-14T09:40:00Z",
    creatorName: "Omar Mohamed",
    defaultMode: "auto",
  },
  {
    id: "51",
    name: "E-commerce Assistant",
    description: "Supports e-commerce operations and customer interactions.",
    createdAt: "2026-05-12T12:55:00Z",
    creatorName: "Dalia Ahmed",
    defaultMode: "agentic",
  },
  {
    id: "52",
    name: "Order Management Assistant",
    description: "Helps track orders and resolve order-related issues.",
    createdAt: "2026-05-10T15:05:00Z",
    creatorName: "Ibrahim Khaled",
    defaultMode: "auto",
  },
  {
    id: "53",
    name: "Feedback Response Assistant",
    description: "Generates appropriate responses to customer feedback.",
    createdAt: "2026-05-08T10:25:00Z",
    creatorName: "Mina Adel",
    defaultMode: "agentic",
  },
  {
    id: "54",
    name: "Business Writing Assistant",
    description:
      "Improves business writing and creates professional documents.",
    createdAt: "2026-05-06T13:45:00Z",
    creatorName: "Rania Hassan",
    defaultMode: "auto",
  },
  {
    id: "55",
    name: "Executive Assistant",
    description:
      "Helps executives organize information, tasks, and priorities.",
    createdAt: "2026-05-04T16:30:00Z",
    creatorName: "Hassan Mahmoud",
    defaultMode: "agentic",
  },
];

const BlueprintTable = () => {
  const [pinnedBlueprints, setPinnedBlueprints] = useState<Set<string>>(
    () => new Set(),
  );
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const pageCount = Math.max(1, Math.ceil(blueprints.length / rowsPerPage));
  const visibleBlueprints = blueprints.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage,
  );
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedBlueprint, setSelectedBlueprint] = useState<Blueprint | null>(
    null,
  );
  const [blueprintToDelete, setBlueprintToDelete] = useState<Blueprint | null>(
    null,
  );

  const handleEditClick = (bluePrint: Blueprint) => {
    setSelectedBlueprint(bluePrint);
    setIsEditOpen(true);
  };

  const handleDeleteClick = (blueprint: Blueprint) => {
    setBlueprintToDelete(blueprint);
  };
  const handleDeleteConfirm = () => {
    setBlueprintToDelete(null);
  };
  return (
    <section className="overflow-hidden">
      <div className="flex items-center justify-between py-3">
        <h2 className="text-xs font-medium text-foreground">All Blueprints</h2>
      </div>

      <div className="flex flex-col gap-1.5 pb-3">
        {visibleBlueprints.map((blueprint) => {
          return (
            <Card
              key={blueprint.id}
              className="min-h-[58px] rounded-[6px] border-border bg-background py-0 shadow-none"
            >
              <CardContent className="grid min-h-[58px] grid-cols-[minmax(0,1fr)_auto] items-center gap-4 px-3 py-2">
                {/* Blueprint information */}
                <div className="min-w-0">
                  <h3 className="truncate text-xs font-medium text-foreground">
                    {blueprint.name}
                  </h3>

                  <p className="truncate text-[0.65rem] text-muted-foreground">
                    {blueprint.description}
                  </p>
                </div>

                {/* Creator + Actions */}
                <div className="flex items-center gap-5">
                  <div className="hidden min-w-[150px] flex-col sm:flex">
                    <span className="text-xs text-foreground">
                      {blueprint.creatorName}
                    </span>

                    <span className="text-[0.65rem] text-muted-foreground">
                      {new Date(blueprint.createdAt).toLocaleString(undefined, {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>

                  <div className="flex items-center gap-1">
                    <Button
                      type="button"
                      variant="ghost"
                      size="icon"
                      title="Edit blueprint"
                      aria-label={`Edit ${blueprint.name}`}
                      className="size-7 text-muted-foreground hover:text-foreground"
                      onClick={() => handleEditClick(blueprint)}
                    >
                      <Pencil className="size-3.5" />
                    </Button>

                    <Button
                      type="button"
                      variant="ghost"
                      size="icon"
                      title="Delete blueprint"
                      aria-label={`Delete ${blueprint.name}`}
                      className="size-7 text-muted-foreground hover:text-foreground"
                      onClick={() => handleDeleteClick(blueprint)}
                    >
                      <Trash className="size-3.5" />
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Pagination */}
      <div className="flex items-center justify-between py-2.5">
        {/* Rows per page */}
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <span>Rows per page</span>

          <Select
            value={String(rowsPerPage)}
            onValueChange={(value) => {
              setRowsPerPage(Number(value));
              setPage(1);
            }}
          >
            <SelectTrigger className="h-8 min-w-[64px] text-xs">
              <SelectValue />
            </SelectTrigger>

            <SelectContent>
              {[10, 25, 50].map((size) => (
                <SelectItem key={size} value={String(size)} className="text-xs">
                  {size}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Pagination controls */}
        <div className="flex items-center gap-1">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            disabled={page === 1}
            onClick={() => setPage((current) => current - 1)}
            className="gap-0.5 px-1 text-xs text-muted-foreground hover:text-foreground"
          >
            <ChevronLeft className="size-4" />
            <span>Previous</span>
          </Button>

          {Array.from({ length: pageCount }, (_, index) => index + 1).map(
            (pageNumber) => (
              <Button
                key={pageNumber}
                type="button"
                variant={page === pageNumber ? "outline" : "ghost"}
                size="icon"
                onClick={() => setPage(pageNumber)}
                className={`size-8 rounded-lg text-xs ${
                  page === pageNumber
                    ? "bg-muted font-semibold text-foreground"
                    : "text-muted-foreground hover:bg-muted/50"
                }`}
              >
                {pageNumber}
              </Button>
            ),
          )}

          <Button
            type="button"
            variant="ghost"
            size="sm"
            disabled={page === pageCount}
            onClick={() => setPage((current) => current + 1)}
            className="gap-0.5 px-1 text-xs text-muted-foreground hover:text-foreground"
          >
            <span>Next</span>
            <ChevronRight className="size-4" />
          </Button>
        </div>
      </div>

      {/* Edit Blueprint Dialog */}
      {selectedBlueprint && (
        <BlueprintDetailsDialog
          open={isEditOpen}
          blueprint={selectedBlueprint}
          onOpenChange={(open) => {
            setIsEditOpen(open);
            if (!open) {
              setSelectedBlueprint(null);
            }
          }}
        />
      )}

      <DeleteBlueprint
        blueprint={blueprintToDelete}
        isDeleting={false}
        onCancel={() => setBlueprintToDelete(null)}
        onConfirm={handleDeleteConfirm}
      />
    </section>
  );
};

export default BlueprintTable;
